import axios from '../utilities/Axios';

export default {
  createCharge: async (data) => (await axios.post('/payment', data)).data.data,
}

